import { createI18n } from 'vue-i18n'
import en from './en.json'
import de from './de.json'

// Get locale from HTML lang attribute (set by Rails)
const getInitialLocale = () => {
  // Check HTML lang attribute
  const htmlLang = document.documentElement.lang
  if (htmlLang && ['en', 'de'].includes(htmlLang)) {
    return htmlLang
  }

  // Check for data attribute on body
  const bodyLocale = document.body.dataset.locale
  if (bodyLocale && ['en', 'de'].includes(bodyLocale)) {
    return bodyLocale
  }

  // Check browser language
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'de'].includes(browserLang)) {
    return browserLang
  }

  return 'en'
}

export const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    de
  }
})

// Helper to update locale dynamically
export const setLocale = (locale) => {
  if (i18n.global.availableLocales.includes(locale)) {
    i18n.global.locale.value = locale
    document.documentElement.lang = locale
  }
}

export default i18n
